<template>
    <el-card class="box-card">
        <!--<div style="margin-bottom: 10px;">-->
            <!--<span>大世界：</span>-->
            <!--<el-select v-model="bigWorldFloor" @change="getFloorChange">-->
                <!--<el-option v-for="item in bigWorldData" :key="item.value" :label="item.label" :value="item.value">-->
                <!--</el-option>-->
            <!--</el-select>-->
        <!--</div>-->

        <el-button-group>
            <el-button type="primary" @click="isShowConnectLine = true">连线</el-button>
            <el-button type="primary" @click="isShowConnectLine = false">标点</el-button>
        </el-button-group>
        <div class="tip" v-if="!isShowConnectLine">Tip:导出按照点击顺序导出，需按照从起点到终点的顺序操作</div>
        <el-form :inline="true">
            <template v-if="isShowConnectLine">
                <el-form-item>
                    <!--<el-select v-model="start" filterable @change="scrollSelectId">-->
                        <!--<el-option v-for="item in mapData" :key="item.id" :value="item.id" :label="(item.id ) +'-' + $t(item.name)" :disabled="item.floor !== bigWorldFloor">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                    <el-cascader
                        v-model="start"
                        :options="bigWorldData"
                        :show-all-levels="false"
                        filterable
                        placeholder='请选择'
                        @change="scrollStartSelectId">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <!--<el-select v-model="end" filterable @change="scrollSelectId">-->
                        <!--<el-option v-for="item in mapData" :key="item.id" :value="item.id" :label="(item.id ) +'-' + $t(item.name)" :disabled="item.floor !== bigWorldFloor">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                    <el-cascader
                        v-model="end"
                        :options="bigWorldData"
                        :show-all-levels="false"
                        filterable
                        placeholder='请选择'
                        @change="scrollEndSelectId">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button @click="createLine">连线</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="exportLine">导出</el-button>
                </el-form-item>
            </template>
            <template v-else>
                <el-form-item>
                    <!--<el-select v-model="start" @change="scrollSelectId">-->
                        <!--<el-option v-for="item in mapData" :key="item.id" :value="item.id" :label="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                    <el-cascader
                        v-model="start"
                        :options="bigWorldData"
                        :show-all-levels="false"
                        filterable
                        placeholder='请选择'
                        @change="scrollStartSelectId">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="end" @change="scrollSelectId">
                        <el-option v-for="item in mapRelationData" :key="item.id" :value="start == item.map_node_id?item.connected_node_id:start == item.connected_node_id?item.map_node_id:''"
                                   :label="start == item.map_node_id?item.connected_node_id:start == item.connected_node_id?item.map_node_id:''" v-if="start == item.map_node_id || start == item.connected_node_id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button @click="jsonAdd">添加红点到json</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="jsonExport">导出json数据</el-button>
                </el-form-item>
                <el-form-item>
                    <el-upload :action="uploadUrl"
                               :show-file-list="false"
                               :on-success="importByJson">
                        <el-button>导入json数据</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showAndHideRedLine">{{isShowRedLine?'隐藏':'显示'}}红线</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button plain @click="open">{{isShowOpenBox?'隐藏':'显示'}}数据格式</el-button>
                </el-form-item>

            </template>
        </el-form>

        <div class="map" id="mapDiv" style="overflow: scroll">
            <img
                id="map"
                :src="require('../../assets/icons/map'+bigWorldFloor+'_relation.jpg')"
                :style="{width:bigWorldFloor == 1?'2500px':bigWorldFloor == 2?'3000px':bigWorldFloor == 7?'2250px':'1750px',height:bigWorldFloor == 1?'2500px':bigWorldFloor == 2?'1100px':bigWorldFloor == 7?'2250px':'1750px'}"
                alt=""
            />
        </div>

        <div class="open-box" v-show="isShowOpenBox">
            <div v-for="(value,key) in importJsonData">
                <div style="width: 100px;">"{{key}}"：[</div>
                <div style="width: 150px;" v-for="item in value">
                    <div style="margin-left: 10px;">{{item}}</div>
                </div>
                <div>]</div>
            </div>
        </div>
    </el-card>
</template>

<script>
    import confApi from '../../service/conf_api'
    import {mapState} from 'vuex';
    import { jsPlumb } from "jsplumb"
    import XLSX from 'xlsx';
    import FileSaver from 'file-saver'
    import {
        apis
    } from '../../lib/apis'

    export default {
        name: "map_relation_editor",
        data () {
            return {
                parseImgUrl: require('../../assets/icons/map1_relation.jpg'),
                pointImg: require('../../assets/icons/node.png'),
                pointSize: 10, //点的大小
                pointSizeW: 12, //点的大小
                pointSizeH: 9, //点的大小
                pointColor:'red',

                mapData: [],
                mapRelationData: [],

                jsplumbSetting: {
                    grid: [10, 10],
                    Anchors: ["TopCenter","RightMiddle","BottomCenter","LeftMiddle"],
                    Container: "mapDiv",
                    Connector: ["Straight"],
                    ConnectionsDetachable: false,
                    DeleteEndpointsOnDetach: false,
                    Endpoint: ["Dot", {radius: 5}], EndpointStyle: {fill: "rgba(255,255,255,0)",outlineWidth: 1},
                    LogEnabled: false,
                    PaintStyle: {stroke: "red",strokeWidth: 4},
                    // HoverPaintStyle: { stroke: "#ff00cc", strokeWidth: 2},
                    // Overlays: [["Arrow",{width: 8,length: 8,location: 1}]],
                    RenderMode: "svg"
                },

                start: '',
                end: '',
                jsonData: new Map(),
                jsonValue: [],
                jsonIndex: 0,
                jsonIdx: 0,

                isShowConnectLine: true,
                // 隐藏/显示红线
                isShowRedLine: true,

                // 导入的json数据
                importJsonData: {},

                // 隐藏/展示数据格式
                isShowOpenBox: false,

                uploadUrl: apis.conf_upload,

                // 大世界层数
                bigWorldFloor: 1,
                bigWorldData: [
                    // {
                    //     label: '源初之地',
                    //     value: 1
                    // },
                    // {
                    //     label: '开拓之地',
                    //     value: 2
                    // },
                    // {
                    //     label: '舛误之地',
                    //     value: 3
                    // },
                    // {
                    //     label: '崩坠之地',
                    //     value: 4
                    // },
                    // {
                    //     label: '虚诞之地',
                    //     value: 5
                    // },
                ]
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        watch: {
            start(n,l) {
                if (n!==l) {
                    this.jsonValue = [];
                    this.jsonIndex = 0;
                    this.jsonIdx++;
                }
            },
            end(n,l) {
                if (n!==l) {
                    this.jsonValue = [];
                    this.jsonIndex = 0;
                    this.jsonIdx++;
                }
            },
            isShowConnectLine(n,l) {
                if (n!==l) {
                    this.start = '';
                    this.end = '';
                }
            },
            bigWorldFloor(n, l) {
                if (n!==l) {
                    $(".marker").remove();
                    jsPlumb.importDefaults(this.jsplumbSetting);
                    jsPlumb.deleteEveryConnection();
                    this.pointAndLine();
                }
            }
        },
        mounted() {
            //-- 铺点连线 --//
            jsPlumb.importDefaults(this.jsplumbSetting);
            jsPlumb.deleteEveryConnection();

            this.getReadData();
            this.pointAndLine();

            jsPlumb.bind('click', function (conn, originalEvent) {
                jsPlumb.deleteConnection(conn);
            });

            document.getElementById("map").oncontextmenu = e => {
                if (e && e.preventDefault) {
                    e.preventDefault();
                } else {
                    window.event.returnValue = false;
                }
                return false;
            };

            document.getElementById("map").onmousedown = e => {
                e = e || window.event;
                if (e.button !== 2) {
                    //判断是否右击
                    /*
                  event.screenX是屏幕左上角到鼠标当前位置的x轴距离;
                  event.clientX是浏览器左上角到鼠标当前位置的x轴距离;
                  event.offsetX是鼠标当前点击控件左上角到鼠标当前位置的x轴距离;
                  */
                    var x = (e.offsetX || e.layerX)*2;
                    var y = (e.offsetY || e.layerY)*2;
                    console.log(x, y);
                    var myImg = document.querySelector("#map");
                    var currWidth = myImg.clientWidth;
                    var currHeight = myImg.clientHeight;
                    var ProportionWidthInImg = x / currWidth;
                    var ProportionHeightInImg = y / currHeight;
                    var div = document.getElementById('point');
                    // if (div !== null) {
                    //     document.getElementById("mapDiv").removeChild(div);
                    // }

                    this.jsonValue.push([x,-y]);
                    this.jsonIndex++;

                    this.createPoint(x,y,this.jsonIdx,this.jsonIndex);
                }
            };

        },
        methods: {
            // 描点
            createPoint(x, y, idx, index) {
                var div = document.createElement("div");
                div.className = "point";
                div.id = "point" + idx + '-' + index;
                y = y + document.getElementById("map").offsetTop - this.pointSize;
                x = x + document.getElementById("map").offsetLeft - this.pointSize;
                div.style.width = this.pointSize  + "px";
                div.style.height = this.pointSize  + "px";
                // div.style.backgroundColor = this.pointColor;
                // div.style.background = "url(" + this.pointImg + ") no-repeat";
                div.style.background = this.pointColor;
                div.style.position = "absolute";
                div.style.left = x/2 + "px";
                div.style.top = y/2 + "px";
                div.oncontextmenu = e => {
                    var id = e.target.id;
                    var jsonValueX = document.getElementById(id).offsetLeft*2 + 10;
                    var jsonValueY = -(document.getElementById(id).offsetTop*2 + 10);
                    for (var i in this.jsonValue) {
                        if (this.jsonValue[i][0] == jsonValueX && this.jsonValue[i][1] == jsonValueY) {
                            this.jsonValue.splice(i,1)
                        }
                    }

                    document.getElementById("mapDiv").removeChild(div);
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    } else {
                        window.event.returnValue = false;
                    }
                    return false;
                };
                document.getElementById("mapDiv").appendChild(div);

                var html = "<div class='map-number' id='point" + idx + '-' + index +"'>" + index + "</div>";

                let placeholder = document.createElement('div');
                placeholder.innerHTML = html;
                document.getElementById("point" + idx + '-' + index).appendChild(placeholder);

            },

            // 创建坐标
            createMarker(x, y, id) {
                if (document.getElementById("mapNumber" + id)) {
                    document.getElementById("mapNumber" + id).parentElement.parentElement.remove();
                }

                var div = document.createElement("div");
                div.className = "marker";
                div.id = "marker" + id;
                y = y + document.getElementById("map").offsetTop - this.pointSizeW / 2;
                x = x + document.getElementById("map").offsetLeft - this.pointSizeH / 2;
                div.style.width = this.pointSizeW  + "px";
                div.style.height = this.pointSizeH  + "px";
                div.style.background = "url(" + this.pointImg + ") no-repeat";
                div.style.backgroundSize = "12px 9px";
                div.style.position = "absolute";
                div.style.left = x/2 + "px";
                div.style.top = y/2 + "px";
                div.oncontextmenu = e => {
                    var id = e.target.id;
                    // document.getElementById("mapDiv").removeChild(div);
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    } else {
                        window.event.returnValue = false;
                    }
                    return false;
                };
                document.getElementById("mapDiv").appendChild(div);


                var html = "<div class='map-number' id='mapNumber" + id +"'>" + id + "</div>";

                let placeholder = document.createElement('div');
                placeholder.innerHTML = html;
                document.getElementById("marker" + id).appendChild(placeholder);
            },

            // 导出连线
            exportLine() {
                var data = jsPlumb.getAllConnections();
                var arr = [
                    ["map_node_relation"],
                    ["客户端","id","floor", "map_node_id","connected_node_id","length"],
                    ["服务端","id","floor", "map_node_id","connected_node_id","length"],
                ];
                data.forEach((item,index) => {
                    var _arr = [];
                    var map_node_id = item.sourceId.split('r')[2];
                    var connected_node_id = item.targetId.split('r')[2];
                    if (data.length-1 == index) {
                        _arr.push('END',(index+1),1,map_node_id,connected_node_id,1);
                    } else {
                        _arr.push('',(index+1),1,map_node_id,connected_node_id,1);
                    }
                    arr.push(_arr);
                })

                const ws= XLSX.utils.aoa_to_sheet(arr);

                /* generate workbook and add the worksheet */
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'MapNodeRelationConfig');

                /* save to file */
                XLSX.writeFile(wb, 'MapNodeRelationConfig地图节点关系.xlsx');
            },

            // 连线
            createLine() {
                jsPlumb.connect({
                    source: 'marker' + this.start,
                    target: 'marker' + this.end,
                    endpoint: 'Dot'
                });
            },

            // 定位到标记
            scrollSelectId(id) {
                var x = document.getElementById('marker' + id).offsetLeft*2;
                var y = document.getElementById('marker' + id).offsetTop*2;
                document.getElementById('mapDiv').scrollTo(x/2-500,y/2-400);
            },

            scrollStartSelectId(data) {
                var id = data[2];
                this.start = id;
                this.bigWorldFloor = data[0];
                var x = document.getElementById('marker' + id).offsetLeft*2;
                var y = document.getElementById('marker' + id).offsetTop*2;
                document.getElementById('mapDiv').scrollTo(x/2-500,y/2-400);
            },

            scrollEndSelectId(data) {
                var id = data[2];
                this.end = id;
                this.bigWorldFloor = data[0];
                var x = document.getElementById('marker' + id).offsetLeft*2;
                var y = document.getElementById('marker' + id).offsetTop*2;
                document.getElementById('mapDiv').scrollTo(x/2-500,y/2-400);
            },

            // 导出标点json数据
            jsonExport() {
                var strMapToObj = this.strMapToObj(this.jsonData);
                var data = JSON.stringify(strMapToObj);
                const blob = new Blob([data], {type: 'application/json'});
                FileSaver.saveAs(blob, 'map.json');
            },

            // 添加标点到json
            jsonAdd() {
                this.jsonData.set((this.start + '-' + this.end), this.jsonValue);
                this.importJsonData = this.strMapToObj(this.jsonData);
            },

            // map转obj
            strMapToObj(strMap) {
                let obj= Object.create(null);
                for (let[k,v] of strMap) {
                    obj[k] = v;
                }
                return obj;
            },

            // 显示/隐藏红线
            showAndHideRedLine() {
                this.isShowRedLine = !this.isShowRedLine;
                if (this.isShowRedLine) {
                    this.pointAndLine();
                } else {
                    jsPlumb.deleteEveryConnection();
                }
            },

            // 铺点连线
            pointAndLine() {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'map_node'
                }).then(res => {
                    this.mapData = res;
                    this.mapData.forEach(item => {
                        if (item.floor == this.bigWorldFloor) {
                            this.createMarker(item.coordinate_x, item.coordinate_y, item.id);
                        }
                    })
                });

                setTimeout(() => {
                    confApi.getReadData({
                        token: this.token,
                        tableName: 'map_node_relation'
                    }).then(res => {
                        this.mapRelationData = res;
                        this.mapRelationData.forEach(item => {
                            if (item.floor == this.bigWorldFloor) {
                                jsPlumb.connect({
                                    source: 'marker' + item.map_node_id,
                                    target: 'marker' + item.connected_node_id,
                                    endpoint: 'Dot'
                                })
                            }
                        });
                    });
                },2000);
            },

            // 导入json数据
            importByJson(res, file, fileList) {
                let reader = new FileReader();
                reader.readAsText(file.raw);
                reader.onload = (e) => {
                    this.importJsonData = JSON.parse(e.target.result);

                    for (let i in this.importJsonData) {
                        this.jsonIdx++;
                        this.jsonIndex = 0;
                        this.importJsonData[i].forEach((item, index)=> {
                            this.jsonIndex++;
                            this.createPoint(item[0],parseInt(item[1].toString().split('-')[1]),this.jsonIdx,this.jsonIndex);
                        })

                        this.jsonData.set((i.split('-')[0] + '-' + i.split('-')[1]), this.importJsonData[i]);
                    }
                };
            },

            open() {
                this.isShowOpenBox = !this.isShowOpenBox;
            },

            getFloorChange() {
                $(".marker").remove();
                jsPlumb.importDefaults(this.jsplumbSetting);
                jsPlumb.deleteEveryConnection();
                this.pointAndLine();
            },

            getReadData() {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'map_node'
                }).then(res => {
                    this.mapNodeList = res;
                    let bigWorldData = [];
                    let mapChildren1 = [];
                    let mapChildren2 = [];
                    let mapChildren3 = [];
                    let mapChildren4 = [];
                    let mapChildren5 = [];
                    let mapChildren6 = [];
                    let mapChildren7 = [];
                    let mapChildren8 = [];
                    let typeChildren1 = [];
                    let typeChildren2 = [];
                    let typeChildren3 = [];
                    let typeChildren4 = [];
                    let typeChildren5 = [];
                    let typeChildren6 = [];
                    let typeChildren7 = [];
                    let typeChildren8 = [];
                    let typeChildren9 = [];
                    let typeChildren10 = [];
                    let typeChildren21 = [];
                    let typeChildren22 = [];
                    let typeChildren23 = [];
                    let typeChildren24 = [];
                    let typeChildren25 = [];
                    let typeChildren26 = [];
                    let typeChildren27 = [];
                    let typeChildren28 = [];
                    let typeChildren29 = [];
                    let typeChildren210 = [];
                    let typeChildren31 = [];
                    let typeChildren32 = [];
                    let typeChildren33 = [];
                    let typeChildren34 = [];
                    let typeChildren35 = [];
                    let typeChildren36 = [];
                    let typeChildren37 = [];
                    let typeChildren38 = [];
                    let typeChildren39 = [];
                    let typeChildren310 = [];
                    let typeChildren41 = [];
                    let typeChildren42 = [];
                    let typeChildren43 = [];
                    let typeChildren44 = [];
                    let typeChildren45 = [];
                    let typeChildren46 = [];
                    let typeChildren47 = [];
                    let typeChildren48 = [];
                    let typeChildren49 = [];
                    let typeChildren410 = [];
                    let typeChildren51 = [];
                    let typeChildren52 = [];
                    let typeChildren53 = [];
                    let typeChildren54 = [];
                    let typeChildren55 = [];
                    let typeChildren56 = [];
                    let typeChildren57 = [];
                    let typeChildren58 = [];
                    let typeChildren59 = [];
                    let typeChildren510 = [];
                    let typeChildren61 = [];
                    let typeChildren62 = [];
                    let typeChildren63 = [];
                    let typeChildren64 = [];
                    let typeChildren65 = [];
                    let typeChildren66 = [];
                    let typeChildren67 = [];
                    let typeChildren68 = [];
                    let typeChildren69 = [];
                    let typeChildren610 = [];
                    let typeChildren71 = [];
                    let typeChildren72 = [];
                    let typeChildren73 = [];
                    let typeChildren74 = [];
                    let typeChildren75 = [];
                    let typeChildren76 = [];
                    let typeChildren77 = [];
                    let typeChildren78 = [];
                    let typeChildren79 = [];
                    let typeChildren710 = [];
                    let typeChildren81 = [];
                    let typeChildren82 = [];
                    let typeChildren83 = [];
                    let typeChildren84 = [];
                    let typeChildren85 = [];
                    let typeChildren86 = [];
                    let typeChildren87 = [];
                    let typeChildren88 = [];
                    let typeChildren89 = [];
                    let typeChildren810 = [];

                    mapChildren1 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren1
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren2
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren3
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren4
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren5
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren6
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren7
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren8
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren9
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren10
                        }
                    ];

                    mapChildren2 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren21
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren22
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren23
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren24
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren25
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren26
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren27
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren28
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren29
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren210
                        }
                    ];

                    mapChildren3 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren31
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren32
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren33
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren34
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren35
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren36
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren37
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren38
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren39
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren310
                        }
                    ];

                    mapChildren4 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren41
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren42
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren43
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren44
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren45
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren46
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren47
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren48
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren49
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren410
                        }
                    ];

                    mapChildren5 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren51
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren52
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren53
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren54
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren55
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren56
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren57
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren58
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren59
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren510
                        }
                    ];

                    mapChildren6 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren61
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren62
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren63
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren64
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren65
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren66
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren67
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren68
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren69
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren610
                        }
                    ];

                    mapChildren7 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren71
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren72
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren73
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren74
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren75
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren76
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren77
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren78
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren79
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren710
                        }
                    ];

                    mapChildren8 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren81
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren82
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren83
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren84
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren85
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren86
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren87
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren88
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren89
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren810
                        }
                    ];


                    bigWorldData = [
                        {
                            label: '源初之地',
                            value: 1,
                            children: mapChildren1
                        },
                        {
                            label: '开拓之地',
                            value: 2,
                            children: mapChildren2
                        },
                        {
                            label: '舛误之地',
                            value: 3,
                            children: mapChildren3
                        },
                        {
                            label: '崩坠之地',
                            value: 4,
                            children: mapChildren4
                        },
                        {
                            label: '诡潮之地',
                            value: 5,
                            children: mapChildren5
                        },
                        {
                            label: 'XX之地',
                            value: 6,
                            children: mapChildren6
                        },
                        {
                            label: '七层之地',
                            value: 7,
                            children: mapChildren7
                        },
                        {
                            label: '八层之地',
                            value: 8,
                            children: mapChildren8
                        },
                    ]

                    for(var i=0;i<=this.mapNodeList.length-1;i++) {
                        let item = this.mapNodeList[i];
                        item.label = (item.id) +'-' + this.$t(item.name);
                        item.value = item.id
                        if (item.floor == 1) {
                            if (item.type == 1) {
                                typeChildren1.push(item);
                            } else if (item.type == 2) {
                                typeChildren2.push(item);
                            } else if (item.type == 3) {
                                typeChildren3.push(item);
                            } else if (item.type == 4) {
                                typeChildren4.push(item);
                            } else if (item.type == 5) {
                                typeChildren5.push(item);
                            } else if (item.type == 6) {
                                typeChildren6.push(item);
                            } else if (item.type == 7) {
                                typeChildren7.push(item);
                            } else if (item.type == 8) {
                                typeChildren8.push(item);
                            } else if (item.type == 9) {
                                typeChildren9.push(item);
                            } else if (item.type == 10) {
                                typeChildren10.push(item);
                            }

                        } else if (item.floor == 2) {
                            if (item.type == 1) {
                                typeChildren21.push(item);
                            } else if (item.type == 2) {
                                typeChildren22.push(item);
                            } else if (item.type == 3) {
                                typeChildren23.push(item);
                            } else if (item.type == 4) {
                                typeChildren24.push(item);
                            } else if (item.type == 5) {
                                typeChildren25.push(item);
                            } else if (item.type == 6) {
                                typeChildren26.push(item);
                            } else if (item.type == 7) {
                                typeChildren27.push(item);
                            } else if (item.type == 8) {
                                typeChildren28.push(item);
                            } else if (item.type == 9) {
                                typeChildren29.push(item);
                            } else if (item.type == 10) {
                                typeChildren210.push(item);
                            }
                        } else if (item.floor == 3) {
                            if (item.type == 1) {
                                typeChildren31.push(item);
                            } else if (item.type == 2) {
                                typeChildren32.push(item);
                            } else if (item.type == 3) {
                                typeChildren33.push(item);
                            } else if (item.type == 4) {
                                typeChildren34.push(item);
                            } else if (item.type == 5) {
                                typeChildren35.push(item);
                            } else if (item.type == 6) {
                                typeChildren36.push(item);
                            } else if (item.type == 7) {
                                typeChildren37.push(item);
                            } else if (item.type == 8) {
                                typeChildren38.push(item);
                            } else if (item.type == 9) {
                                typeChildren39.push(item);
                            } else if (item.type == 10) {
                                typeChildren310.push(item);
                            }
                        } else if (item.floor == 4) {
                            if (item.type == 1) {
                                typeChildren41.push(item);
                            } else if (item.type == 2) {
                                typeChildren42.push(item);
                            } else if (item.type == 3) {
                                typeChildren43.push(item);
                            } else if (item.type == 4) {
                                typeChildren44.push(item);
                            } else if (item.type == 5) {
                                typeChildren45.push(item);
                            } else if (item.type == 6) {
                                typeChildren46.push(item);
                            } else if (item.type == 7) {
                                typeChildren47.push(item);
                            } else if (item.type == 8) {
                                typeChildren48.push(item);
                            } else if (item.type == 9) {
                                typeChildren49.push(item);
                            } else if (item.type == 10) {
                                typeChildren410.push(item);
                            }
                        } else if (item.floor == 5) {
                            if (item.type == 1) {
                                typeChildren51.push(item);
                            } else if (item.type == 2) {
                                typeChildren52.push(item);
                            } else if (item.type == 3) {
                                typeChildren53.push(item);
                            } else if (item.type == 4) {
                                typeChildren54.push(item);
                            } else if (item.type == 5) {
                                typeChildren55.push(item);
                            } else if (item.type == 6) {
                                typeChildren56.push(item);
                            } else if (item.type == 7) {
                                typeChildren57.push(item);
                            } else if (item.type == 8) {
                                typeChildren58.push(item);
                            } else if (item.type == 9) {
                                typeChildren59.push(item);
                            } else if (item.type == 10) {
                                typeChildren510.push(item);
                            }
                        } else if (item.floor == 6) {
                            if (item.type == 1) {
                                typeChildren61.push(item);
                            } else if (item.type == 2) {
                                typeChildren62.push(item);
                            } else if (item.type == 3) {
                                typeChildren63.push(item);
                            } else if (item.type == 4) {
                                typeChildren64.push(item);
                            } else if (item.type == 5) {
                                typeChildren65.push(item);
                            } else if (item.type == 6) {
                                typeChildren66.push(item);
                            } else if (item.type == 7) {
                                typeChildren67.push(item);
                            } else if (item.type == 8) {
                                typeChildren68.push(item);
                            } else if (item.type == 9) {
                                typeChildren69.push(item);
                            } else if (item.type == 10) {
                                typeChildren610.push(item);
                            }
                        } else if (item.floor == 7) {
                            if (item.type == 1) {
                                typeChildren71.push(item);
                            } else if (item.type == 2) {
                                typeChildren72.push(item);
                            } else if (item.type == 3) {
                                typeChildren73.push(item);
                            } else if (item.type == 4) {
                                typeChildren74.push(item);
                            } else if (item.type == 5) {
                                typeChildren75.push(item);
                            } else if (item.type == 6) {
                                typeChildren76.push(item);
                            } else if (item.type == 7) {
                                typeChildren77.push(item);
                            } else if (item.type == 8) {
                                typeChildren78.push(item);
                            } else if (item.type == 9) {
                                typeChildren79.push(item);
                            } else if (item.type == 10) {
                                typeChildren710.push(item);
                            }
                        } else if (item.floor == 8) {
                            if (item.type == 1) {
                                typeChildren81.push(item);
                            } else if (item.type == 2) {
                                typeChildren82.push(item);
                            } else if (item.type == 3) {
                                typeChildren83.push(item);
                            } else if (item.type == 4) {
                                typeChildren84.push(item);
                            } else if (item.type == 5) {
                                typeChildren85.push(item);
                            } else if (item.type == 6) {
                                typeChildren86.push(item);
                            } else if (item.type == 7) {
                                typeChildren87.push(item);
                            } else if (item.type == 8) {
                                typeChildren88.push(item);
                            } else if (item.type == 9) {
                                typeChildren89.push(item);
                            } else if (item.type == 10) {
                                typeChildren810.push(item);
                            }
                        }
                    }
                    this.bigWorldData = bigWorldData;
                })
            },
        }
    }
</script>

<style scoped>

</style>

<style lang="less">
    #mapDiv {
        width: 100%;
        height: 800px;

        position: relative;
        img {
            display: inline-block;
            z-index: 1;
        }
        .marker {
            position: absolute;
            border-radius: 50%;
            z-index: 999;

            .map-number {
                font-size: 6px !important;
                font-weight: bold;
                z-index: 9999;
                line-height: 1 !important;
            }
        }

        .rotate {
            background-color: crimson;
            height: 5px;
            position: absolute;
            z-index: 999;
        }

        .point{
            position:absolute;
            border-radius: 50%;
            z-index: 999;

            .map-number {
                font-size: 6px !important;
                font-weight: bold;
                z-index: 9999;
                line-height: 1 !important;
            }
        }
    }

    .tip {
        color: red;
        display: inline-block;
    }

    .open-box {
        width: 200px;
        padding: 14px 26px 14px 13px;
        border-radius: 8px;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
        position: fixed;
        background-color: #FFFFFF;
        top: 250px;
        right: 60px;
        z-index: 99999;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
    }
</style>



// WEBPACK FOOTER //
// src/views/map_barrier/map_relation_editor.vue